/**
 * Music component view options for displaying sheet music
 * @module musicViewOptions
 * @category Music
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * Practice view
 * @type {string}
 */
export const PRACTICE = "practice";

/**
 * Performance view
 * @type {string}
 */
export const PERFORMANCE = "performance";

/**
 * Exercise view
 * @type {string}
 */
export const EXERCISE = "exercise";
